module.exports = __webpack_public_path__ + "img/404.85cea413.svg";